module.exports = __webpack_public_path__ + "static/hkgrotesk-medium-5113a8916ed62282c1c13d49b12e222a.woff";